export default __webpack_public_path__ + "static/media/thue_xe_co_tai_xe_tphcm_gia_re.465b3169.png";